import axios from 'axios'

const states = {
  id: '',
  email: '',
  uuid: '',
  name: '',
  nric: '',
  phoneNo: '',
  ranking: '',
  picture: '',
  teamieData: ''
}

const actions = {}

const mutations = {
  set_email: (state, email) => {
    state.email = email
  },

  set_uuid: (state, uuid) => {
    state.uuid = uuid
  },

  set_name: (state, name) => {
    state.name = name
  },

  set_nric: (state, nric) => {
    state.nric = nric.replace(/-/g, '')
  },

  set_phoneNo: (state, phoneNo) => {
    state.phoneNo = phoneNo
  },

  set_ranking: (state, ranking) => {
    state.ranking = ranking
  },

  set_picture: (state, picture) => {
    state.picture = picture
  },

  set_teamieData: (state, teamieData) => {
    state.teamieData = teamieData
  }
}

const getters = {}

export default {
  namespaced: true,
  states,
  actions,
  mutations,
  getters
}
